import React, { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import api from '../utils/api';
import Loader from "../lib/components/Loader";
import UserDetails from "../User/UserDetails";

const goBackButton = <Link to='/admin'><button className="btn btn-primary">Go back</button></Link>;

const UserEdit = () => {
    const [user, updateUser] = useState({});
    const [loadingUser, updateLoadingUser] = useState(true);
    const [error, updateError] = useState(null);
    const [permissions, updatePermissions] = useState([]);
    const [loadingPermissions, updateLoadingPermissions] = useState(true);
    const [permission, updatePermission] = useState('admin');
    const [showDeleteConfirm, updateShowDeleteConfirm] = useState(false);

    const { id } = useParams();

    const getUser = () => {
        updateLoadingUser(true);
        api.get(`/api/v1/user/${id}`).then(({ data }) => {
            updateUser(data);
        }).catch((err) => {
            console.error(`Failed to get user, ${err}`);
            updateError('Something went wrong!');
        }).finally(() => {
            updateLoadingUser(false);
        });
    };

    // Get user
    useEffect(getUser, []);

    // Get permissions
    useEffect(() => {
        updateLoadingPermissions(true);
        api.get('/api/v1/user/permissions').then(({ data }) => {
            updatePermissions(data);
        }).catch((err) => {
            console.error(`Failed to get permissions, ${err}`);
        }).finally(() => {
            updateLoadingPermissions(false);
        });
    }, []);

    if(error) {
        return <>
            <h2>{error}</h2>
            {goBackButton}
        </>;
    }

    if(loadingUser) {
        return <Loader/>;
    }

    // this is funky but whatever
    if(!user) {
        return <Navigate to='/admin'/>;
    }

    const handleSetPermissions = (e) => {
        e.preventDefault();
        api.patch('/api/v1/user/grantPermissions', { id: id, permission }).then(() => {
            getUser();
        }).catch((err) => {
            console.error(`Failed to set permissions, ${err}`);
        });
    };

    const deleteAction = () => {
        api.delete(`/api/v1/user/${id}`).then(() => {
            updateShowDeleteConfirm(false);
            // this is funky but whatever
            updateUser(null);
        }).catch((err) => {
            console.error(`Failed to delete user, ${err}`);
        });
    }

    return (
        <div>
            <h2>User Edit</h2>
            <h3>User: {user.username}</h3>
            <UserDetails user={user} />
            <div>
                <div className="mb-2">
                    <h4>Set permissions</h4>
                    <div className="input-group mb-3">
                        {loadingPermissions ? <Loader/> : <select className="custom-select" onChange={(e) => updatePermission(e.target.value)}>
                            {permissions.map((permission, index) => (
                                <option key={index} value={permission}>{permission}</option>
                            ))}
                            </select>
                        }
                    </div>
                    <button className="btn btn-primary" onClick={handleSetPermissions}>Set Permission</button>
                </div>
                <div className="mb-2">
                    <button className="btn btn-warning" onClick={() => updateShowDeleteConfirm(true)}>Delete user</button>
                    {showDeleteConfirm && <div className="text-center">
                        <div className="alert alert-danger">All deletions are permanent, are you sure you want to delete this user?</div>
                        <button className="btn btn-danger" onClick={deleteAction}>Confirm Deletion</button>
                    </div>}
                </div>
                <div className="mb-2">
                    {goBackButton}
                </div>
            </div>
        </div>
    );
};

export default UserEdit;